import config from '@bedrock-rdk/config';
import { facets } from '../../modules/search/customer/default/search.constants';

export default new (class Algolia {
  constructor() {
    this.sdk = null;
    this.client = null;
    this.indices = null;
  }

  _buildSearchQueryParams(query, index) {
    if (!this.indices[index]) return [];

    const { algolia } = config;

    const queryResult = Object.values(facets).map(facet => ({
      indexName: this.indices[index],
      query,
      params: {
        hitsPerPage: 20,
        facetFilters: algolia.platformCode
          ? [[`metadata.item_type:${facet}`], [`metadata.platforms_assets:${algolia.platformCode}`]]
          : [`metadata.item_type:${facet}`],
      },
    }));

    return queryResult;
  }

  async init() {
    this.sdk = await import('algoliasearch');

    const { id, key, indices } = config.algolia;

    this.client = this.sdk.default(id, key);
    this.indices = indices;
  }

  extractFacetFromQuery(query) {
    let facetResult = null;
    Object.values(facets).forEach(facet => {
      if (query.search(facet) !== -1) {
        facetResult = facet;
      }
    });

    return facetResult;
  }

  search(input, index = 'default') {
    const queryParams = this._buildSearchQueryParams(input, index);

    return this.client.multipleQueries(queryParams);
  }
})();
